import React, { Component } from 'react';
import { Container, Tabs, Tab, Button, Modal } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaArrowRight, FaArrowDown, FaBookmark, FaAsterisk, FaBook, FaXmark, FaQuoteRight, FaPlus } from 'react-icons/fa6';
import { GetText, ReplaceText, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../../config/helper';
import Loading from '../../inc/Loading';
import TagHeaders from '../../inc/Headers';
import '../../config/global';
import '../../css/jumbotron.css';
import ImgLogoGemini from '../../img/logo_gemini_academy.png';
import ImgSharePrompt from '../../img/pic_share_prompt.png';
import ImgOpenThread from '../../img/pic_share_thread.png';
import ImgBgStories from '../../img/banner_lp_gemini.jpg';
import LibraryHomeLP from '../../inc/library/HomeLP';
import PromptBlock from '../../inc/prompt/Block';
import PromptForm from '../../inc/prompt/Form';
import DiscussionList from '../../inc/discussion/List';
import DiscussionForm from '../../inc/discussion/Form';
import ModalStoriesForm from './StoriesForm';

const authKey2 = global.config.kindcode.training[1]+global.config.authBearerKey;
const authKey3 = global.config.kindcode.training[0]+global.config.authBearerKey;
const authKey4 = global.config.kindcode.training[21]+global.config.authBearerKey;

const authKey5 = global.config.kindcode.training[18]+global.config.authBearerKey;
const authKey6 = global.config.kindcode.training[22]+global.config.authBearerKey;
const authKey7 = global.config.kindcode.training[23]+global.config.authBearerKey;


function getStoriesData () {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","category":"'+global.config.bannerType[2].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/storieslist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey5
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}

function getThreadData () {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","category":"'+global.config.bannerType[2].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/threadlist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey6
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}

function getPromptData () {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","category":"'+global.config.bannerType[2].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/promptlist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey7
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}

function getBannerData() {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","category":"'+global.config.bannerType[2].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/bannerlist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey4
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}
function getLibraryData() {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly"}';
    var dataSend = JSON.parse(dataText);
    
    fetch(global.config.urlLink+"/librarylist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey2
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      var librarySend = {};
      var resultData = [];
      var resultDataCategory = [];
      var inum=0;

      if(resultJson.values.length > 0) {
        var listLibraryGemini = resultJson.values.filter(dataItem => dataItem.content.categoryName === global.config.specialCategory[0].value);
        if(listLibraryGemini.length > 0) {
          for(var i=0; i<listLibraryGemini.length; i++) {
              var contents = listLibraryGemini[i].content;
              contents.id = listLibraryGemini[i].docid;
              resultData.push(contents);
              if (resultDataCategory.indexOf(contents.categoryName) < 0) {
                resultDataCategory.push(contents.categoryName);
              }

              if(i === (listLibraryGemini.length-1)) {
                var resData = [resultData, resultDataCategory];
              }
              
          }
          if(resData !== undefined ) { 
            librarySend.librarydata = resData[0];
            librarySend.librarycategory = resData[1];
            resolve(librarySend); 
          }
        } else {
          librarySend.librarydata = resultData;
          librarySend.librarycategory = resultDataCategory;
          resolve(librarySend);
        }
                
      } else {
        librarySend.librarydata = resultData;
        librarySend.librarycategory = resultDataCategory;
        resolve(librarySend);
      }
    });
  });
}

function getUserOrder() {
  return new Promise((resolve) => {
    var dataSend = { docid: localStorage.getItem('doc_id') }
    fetch(global.config.urlLink+"/traininguserview", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey3
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong.');
      }
    }).then(resJson => {
      var userOrderSend = {};
      userOrderSend.purchase = resJson.values[0].scontent2;
      userOrderSend.enrolls = resJson.values[0].scontent3;
      resolve(userOrderSend);
    });
  });
}
async function getAllDatas() {
    const libraryresult = getLibraryData();
    const userorderresult = getUserOrder();
    const bannerresult = getBannerData();
    const promptresult = getPromptData();
    const threadresult = getThreadData();
    const storiesresult = getStoriesData();
    

    const [thing1, thing2, thing3, thing4, thing5, thing6] = await Promise.all([libraryresult, userorderresult, bannerresult, promptresult, threadresult, storiesresult]);
    var arrReturnValue = {};
    arrReturnValue.librarydata = thing1.librarydata;
    arrReturnValue.librarycategory = thing1.librarycategory;

    
    arrReturnValue.purchase = thing2.purchase;
    arrReturnValue.enrolls = thing2.enrolls;
    
    arrReturnValue.bannerdata = thing3;

    arrReturnValue.promptdata = thing4;
    arrReturnValue.threaddata = thing5;
    arrReturnValue.storiesdata = thing6;

    return arrReturnValue;
}
export default class HomeGeminiLP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      memberStatus: localStorage.getItem('status'),
      activePage: '',
      libraryList: [],
      libraryCategories: [],
      libraryEnrolled: [],
      bannerList: [],
      promptbankList: [],
      threadList: [],
      storiesList: [],
      isLoad: false,
      modal_show_sstories: false,
      modal_show_prompt: false,
      modal_show_thread: false
    }
  }
  handlePopOpen(name) {
    this.setState({ 
      [name]: true,
    });
  }
  handlePopClose(name) {
    this.setState({ 
      [name]: false,
    });
  }
  loadContentThread(contents) {
    
  }
  componentDidMount() {    
    var currentURL = window.location.pathname;
    var arrPath = currentURL.split('/');
    
    getAllDatas().then((response) => {
      this.setState({
        activePage: arrPath[1],
        libraryList: response.librarydata,
        libraryCategories: response.librarycategory,
        libraryEnrolled: response.enrolls.filter(libEnrollItem => (libEnrollItem.subcontent.libraryPicture !== undefined && libEnrollItem.subcontent.libraryPicture !== "")),
        bannerList: response.bannerdata,
        promptbankList: response.promptdata,
        threadList: response.threaddata,
        storiesList: response.storiesdata,
        isLoad: true
      }) 
    });
  }

  render() {
    return (
      <div className="home-gemini">
        <TagHeaders value={
                        {	
                          docid: '', 
                          title: 'Novaio Academy - Gemini Academy', 
                          description: '',
                          links: global.config.urlHost+'/'+this.state.activePage
                        }
                      }/>
        <section>
          <Container className='mb-4'>
            <div className='text-center'><img src={ImgLogoGemini} className='logo'/></div>
          </Container>
        </section>
        {
          this.state.isLoad === true ? 
            this.state.bannerList.length > 0 ? (
              <section>
                <Container className='mb-5'>
                  <Carousel id="banner-home-geminipage" 
                    swipeable={false}
                    infinite={true}
                    autoPlay={this.state.bannerList.length < 2? false : true}
                    autoPlaySpeed={3000}
                    transitionDuration={500}
                    containerClass="carousel-container"
                    keyBoardControl={true}
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    pauseOnHover={true} 
                    arrows={this.state.bannerList.length < 2? false : true}
                    responsive={{
                      superLargeDesktop: {
                        // the naming can be any, depends on you.
                        breakpoint: { max: 4000, min: 3000 },
                        items: 1
                      },
                      desktop: {
                        breakpoint: { max: 3000, min: 1024 },
                        items: 1 // Shows 5 items on desktop screens
                      },
                      tablet: {
                        breakpoint: { max: 1024, min: 464 },
                        items: 1 // Shows 3 items on tablets
                      },
                      mobile: {
                        breakpoint: { max: 464, min: 0 },
                        items: 1 // Shows 1 item on mobile devices
                      }
                    }}
                    // slide={true} 
                    // fade={true} 
                    // indicators={false}
                  >
                    {
                      this.state.bannerList
                      .sort((a,b) => b.content.bannerNumber - a.content.bannerNumber)
                      .map((bannerItem, a) => {
                        var bannerListData = bannerItem.content;
                        return (
                          
                          <div className="align-items-center mx-0 w-full">
                            {(bannerListData.bannerLinkurl !== "" && bannerListData.bannerLinkurl !== undefined && bannerListData.bannerLinkurl !== ".")? 
                              <a href={bannerListData.bannerLinkurl} target={bannerListData.bannerTargeturl} noreferrer><img src={bannerListData.bannerFileurl} className="img-fluid w-100 rounded"  /></a>
                            : <img src={bannerListData.bannerFileurl} className="img-fluid w-100 rounded" alt="" border="0" />
                            }
                          </div>
                          
                        )
                      })
                    } 
                    </Carousel>
                </Container>
              </section>
            ) : (
              <></>
            )
          : <section><Container className='mb-4'><div style={{height:"380px"}}></div></Container></section>
        }
        
        {
          this.state.isLoad === true ? 
            this.state.libraryList.length > 0 ? (
              <section>
                <Container>
                  <div className="br-8">
                    {
                      GetText() ? (
                        <>
                          <h4 className="text-start mb-1">Pelatihan</h4>
                          <p className="text-start mb-4">Tingkatkan keterampilan Anda tentang Google Gemini yang dapat dipelajari kapan saja dan di mana saja!</p>
                        </>
                      ) : (
                        <>
                          <h4 className="text-start mb-1">Explore Course</h4>
                          <p className="text-start mb-4">Improve your skills about Google Gemini that can be studied anytime, anywhere!</p>
                        </>                      
                      )
                    }
                    
                    
                      <Carousel id="library-home-geminipage" 
                        swipeable={true}
                        infinite={true}
                        autoPlay={this.state.libraryList.length < 4? false : true}
                        autoPlaySpeed={3000}
                        transitionDuration={500}
                        containerClass="carousel-container"
                        keyBoardControl={true}
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                        pauseOnHover={true} 
                        arrows={this.state.libraryList.length < 4? false:true}
                        
                        responsive={{
                          superLargeDesktop: {
                            // the naming can be any, depends on you.
                            breakpoint: { max: 4000, min: 3000 },
                            items: 5
                          },
                          desktop: {
                            breakpoint: { max: 3000, min: 1024 },
                            items: 4 // Shows 5 items on desktop screens
                          },
                          tablet: {
                            breakpoint: { max: 1024, min: 768 },
                            items: 3// Shows 3 items on tablets
                          },
                          smalltablet: {
                            breakpoint: { max: 768, min: 464 },
                            items: 2.5// Shows 3 items on tablets
                          },
                          mobile: {
                            breakpoint: { max: 464, min: 320 },
                            items: 2 // Shows 1 item on mobile devices
                          },
                          smallmobile: {
                            breakpoint: { max: 320, min: 0 },
                            items: 1 // Shows 1 item on mobile devices
                          }
                        }}
                        // slide={true} 
                        // fade={true} 
                        // indicators={false}
                      >
                       
                        {
                          this.state.libraryList
                          .sort((a, b) => a.libraryTitle.localeCompare(b.libraryTitle))                        
                          .map((libraryItem, j) => {
                            var libEnroll = this.state.libraryEnrolled.filter(dataItem => dataItem.subcontent.libraryId === libraryItem.id);
                            if(libEnroll.length > 0) { libraryItem.enrolled = libEnroll[0].subcontent; }
                            return (
                              <div className="item-content" key={j} >
                                <LibraryHomeLP value={libraryItem}/>
                              </div>
                            )
                          })
                        }
                        
                      </Carousel>
                     
                    
                   
                  </div>
                </Container>
                <div className="separator"><div className="icon"><FaBookmark className="bg2-secondary"/></div></div>
              </section>
            ) : <></>
            : <Loading value={{id:'library-area', divstyle:{}, componentstyle: {}}}/>
        }


            <section>
              <Container>
                <div className="row">
                  <div className="col-md-6">
                    <div className="bg-light p-4 br-8" style={{height: "420px"}}>
                      <h4 className="text-start mb-4">{GetText() ? "Koleksi Prompting" : "Prompting Collection"}</h4>
                      {
                        (this.state.promptbankList.length > 0)? (
                          this.state.promptbankList
                          .sort((c,d) => d.content.createDate._seconds - c.content.createDate._seconds)
                          .slice(0, 2)
                          .map((promptItem, j) => {
                            var promptMyLike={id:"",status:"",createdby:""}, numLike=0, numDislike=0;
                            var promptLikeContent = promptItem.subcontentlist;
                            if(promptLikeContent !== undefined) {
                              var promptLikeMyStatus = promptLikeContent.filter(dataItem => dataItem.subcontent.createById === this.state.memberId);
                              if(promptLikeMyStatus.length > 0) {
                                promptMyLike = {
                                  "id": promptLikeMyStatus[0].subdocid,
                                  "status": promptLikeMyStatus[0].subcontent.likeStatus,
                                  "createdby":  promptLikeMyStatus[0].subcontent.createById
                                }
                              }
                              promptLikeContent.map((promptItemLike, k) => {
                                if(promptItemLike.subcontent.likeStatus === global.config.likeStatus[0]) { numLike++; }
                                else if(promptItemLike.subcontent.likeStatus === global.config.likeStatus[1]) { numDislike++; }
                              
                              })
                            }

                            var promptListSend = promptItem.content;
                            promptListSend.id = promptItem.docid;
                            promptListSend.activePage = this.state.activePage;
                            promptListSend.likeStatus = promptMyLike.status;
                            promptListSend.likeStatusId = promptMyLike.id;
                            promptListSend.likeStatusUser = promptMyLike.createdby;
                            promptListSend.numLike = numLike;
                            promptListSend.numDislike = numDislike;
                            promptListSend.type="home";
                            return (
                              <PromptBlock value={promptListSend} key={"prompt-"+j}/>
                            )
                          })
  
                        ) : (
                          <div className="d-flex justify-content-center align-items-center">
                            {/* The content to be centered */}
                            <div className="text-center p-3">
                              <img src={ImgSharePrompt} width="150"/><br/>
                              <Button className="mt-2" variant="primary" size="md" type="button" value="Share Prompt" id="shareprompt" onClick={this.handlePopOpen.bind(this,"modal_show_prompt")}>{GetText() ? "Bagikan Prompt Anda" : "Share your prompt"}</Button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    { (this.state.promptbankList.length > 2) ? 
                      <div className="mt-3 text-center text-md-end">
                        <a href={"/"+this.state.activePage+"/prompt"} className="link-more"><strong>{GetText() ? "Selengkapnya" : "View More"} <FaArrowRight/></strong></a>
                      </div>
                      : 
                      <div className="mt-3 text-center text-md-end">
                        <a onClick={this.handlePopOpen.bind(this,"modal_show_prompt")} className="link-more"><strong>{GetText() ? "Bagikan Prompt Anda" : "Share your prompt"} <FaPlus /></strong></a>
                      </div>
                      
                    }
                  </div>

                  <div className="col-md-6">
                    <div className="bg-light p-4 br-8" style={{height: "420px"}}>
                      <h4 className="text-start mb-4">{GetText() ? "Ruang Diskusi" : "Discussion Room"}</h4>
                      { 
                        (this.state.threadList.length > 0)? (
                          <DiscussionList value={{data:this.state.threadList, activePage: this.state.activePage}} />
  
                        ) : (
                          <div className="d-flex justify-content-center align-items-center">
                            {/* The content to be centered */}
                            <div className="text-center p-3">
                              <img src={ImgOpenThread} width="150"/><br/>
                              <Button className="mt-2" variant="primary" size="md" type="button" value="Open Thread" id="openthread" onClick={this.handlePopOpen.bind(this,"modal_show_thread")}>{GetText() ? "Buka Ruang Diskusi" : "Open Discussion"}</Button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    { (this.state.threadList.length > 2) ? 
                      <div className="mt-3 text-center text-md-end">
                        <a href={"/"+this.state.activePage+"/discussion"} className="link-more"><strong>{GetText() ? "Selengkapnya" : "View More"} <FaArrowRight/></strong></a>
                      </div>
                       : 
                       <div className="mt-3 text-center text-md-end">
                         <a onClick={this.handlePopOpen.bind(this,"modal_show_thread")} className="link-more"><strong>{GetText() ? "Buka Ruang Diskusi" : "Open Discussion"} <FaPlus /></strong></a>
                       </div>
                    }
                  </div>
                </div>
              </Container>
              <div className="separator"><div className="icon"><FaAsterisk className="bg2-secondary"/></div></div>
            </section>
            <section>
              <Container>
                <div className="embed-wrapper">
                  <div className="embed-container" /*style={{display: 'none'}}*/>
                    <iframe className="embed-content" key="ds-001" frameBorder="0" title="" 
                      src="https://datastudio.google.com/embed/reporting/796ac974-e722-4e8a-9d0d-02145ce3b41e/page/f6h3F" 
                      allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                    ></iframe>
                  </div>
                </div>
              </Container>
              <div className="separator"><div className="icon"><FaAsterisk className="bg2-secondary"/></div></div>
            </section>
            {
              this.state.storiesList.length > 0 ? (
                <section>
                  <Container className=' d-flex justify-content-center'>
                    <div className="br-8 w-90">
                      {
                        GetText() ? (
                          <div className='mb-4'>
                            <h2 className="text-center mb-4">Mengapa suka menggunakan Gemini?</h2>
                            <p className="text-center mb-4 ms-5 me-5 lead">Mengubah rasa ingin tahu menjadi hasil yang nyata — orang-orang menggunakan Google Gemini dan alat pembelajaran AI untuk memulai dari pemula hingga mencapai prestasi, lebih cepat dari sebelumnya.</p>
                          </div>
                        ) : (
                          <div className='mb-4 ms-4 me-4'>
                            <h2 className="text-center mb-1">Why people use Gemini?</h2>
                            <p className="text-center mb-4 ps-5 pe-5 lead">Turning curiosity into results — people are using Google Gemini and AI learning tools to start from beginner to achiever, faster than ever.</p>
                          </div>
                        )
                      }
                      
                      
                        <Carousel id="stories-home-geminipage" 
                          swipeable={true}
                          infinite={true}
                          autoPlay={this.state.storiesList.length < 0? false : true}
                          autoPlaySpeed={3000}
                          transitionDuration={500}
                          containerClass="carousel-container"
                          keyBoardControl={true}
                          removeArrowOnDeviceType={["tablet", "mobile"]}
                          pauseOnHover={true} 
                          arrows={this.state.storiesList.length < 0? false:true}
                          
                          responsive={{
                            superLargeDesktop: {
                              // the naming can be any, depends on you.
                              breakpoint: { max: 4000, min: 3000 },
                              items: 1
                            },
                            desktop: {
                              breakpoint: { max: 3000, min: 1024 },
                              items: 1 // Shows 5 items on desktop screens
                            },
                            tablet: {
                              breakpoint: { max: 1024, min: 768 },
                              items: 1 // Shows 3 items on tablets
                            },
                            smalltablet: {
                              breakpoint: { max: 768, min: 464 },
                              items: 1// Shows 3 items on tablets
                            },
                            mobile: {
                              breakpoint: { max: 464, min: 320 },
                              items: 1 // Shows 1 item on mobile devices
                            },
                            smallmobile: {
                              breakpoint: { max: 320, min: 0 },
                              items: 1 // Shows 1 item on mobile devices
                            }
                          }}
                          // slide={true} 
                          // fade={true} 
                          // indicators={false}
                        >
                        
                          {
                            this.state.storiesList
                            .sort((a, b) => a.content.storiesSortNumber - b.content.storiesSortNumber)
                            .map((storiesItem, s) => {
                              var storiesProfiles = storiesItem.content.storiesName;
                              if(storiesItem.content.storiesPosition !== undefined && storiesItem.content.storiesPosition !== "") {
                                storiesProfiles += ", "+storiesItem.content.storiesPosition;
                              }
                              return (
                                <div className="item-content" key={s} >
                                  <div className='d-flex justify-content-center'>
                                    <div className='bg-light br-8 w-80 ' style={{height:"200px", color:"#666", fontSize: "16px", overflowY:"auto"}}>
                                      <div className='d-flex align-items-center h-100 ms-3 me-3'>
                                        <div className='mx-auto text-center mt-3'>
                                          <p className='text-monospace'><FaQuoteRight className='me-2'/>{storiesItem.content.storiesMessage}<FaQuoteRight className='ms-2' /> </p>
                                          <p className='fw-light fst-italic'>— {storiesProfiles} —</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })
                          }
                          
                        </Carousel>
                      
                      
                    
                    </div>
                    
                  </Container>
                  <div className="separator"><div className="icon"><FaBookmark className="bg2-secondary"/></div></div>
                </section>
              ) : <></>
            }
            <section>
              <Container>
                <div className="text-center text-white jumbotron background-cover" style={{backgroundImage: `url(${ImgBgStories})`}}>
                  {
                    GetText() ? (
                      <div className='d-flex justify-content-end'>
                        <div style={{width: "700px"}}>
                          <h2>Bagikan pengalaman Anda!</h2>
                          <p>Anda memiliki pengalaman atau cerita yang menarik selama menggunakan Google Gemini?<br/>
                          Atau saat mengikuti pelatihan disini? </p>
                          <a onClick={this.handlePopOpen.bind(this,"modal_show_sstories")} className="btn btn-lg btn-primary mt-3">Bagikan disini!</a>
                        </div>
                      </div>
                    ) : (
                      <div className='d-flex justify-content-end'>
                        <div style={{width: "700px"}}>
                          <h2>Share your experience!</h2>
                          <p>Do you have any interesting experiences or stories when using Google Gemini?<br />Or from participating in the training here?</p>
                          <a onClick={this.handlePopOpen.bind(this,"modal_show_sstories")} className="btn btn-lg btn-primary mt-3">Share here!</a>
                        </div>
                      </div>
                    )
                  }
                </div>
              </Container>
            </section>

        

          <Modal animation={false} show={this.state.modal_show_sstories} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_sstories")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Bagikan pengalaman Anda" : "Share your stories"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ModalStoriesForm />
            </Modal.Body>
          </Modal>

          <Modal animation={false} show={this.state.modal_show_prompt} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_prompt")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Bagikan prompt Anda" : "Share your prompt"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <PromptForm value={{"currpage": this.state.activePage}} />
            </Modal.Body>
          </Modal>

          {this.state.activePage !== "" && <Modal animation={false} show={this.state.modal_show_thread} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_thread")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Buka Ruang Diskusi" : "Open Discussion Room"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DiscussionForm value={{"currpage": this.state.activePage}} />
            </Modal.Body>
          </Modal> }
      </div>
    );
  }
}